module.exports = __webpack_public_path__ + "img/avatar5.ef40342e.png";